import moment from "moment";

export function dateHelper(date) {
  const now = moment();
  const m = moment(date);

  const diffDays = now.diff(m, "days");
  const diffWeeks = now.diff(m, "weeks");
  const diffMonths = now.diff(m, "months");

  // 0–6 days ago → "X day(s) ago"
  if (diffDays <= 6) {
    return diffDays === 0
      ? "today"
      : `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
  }

  // 7–13 days → "last week"
  if (diffWeeks === 1) return "last week";

  // 2–3 weeks → "X weeks ago"
  if (diffWeeks >= 2 && diffWeeks <= 3) {
    return `${diffWeeks} weeks ago`;
  }

  // Last month (approx): diffMonths === 1
  if (diffMonths === 1) return "last month";

  // 2 months ago
  if (diffMonths === 2) return "2 months ago";

  // More than 2 months → "31 Dec, 2024"
  return m.format("D MMM, YYYY");
}
